import { i18n, initI18n } from 'i18n/i18n'

const toggleInputType = (event: Event): void => {
  const $inputField = document.querySelector("input[name='password']") as HTMLInputElement
  const $button = event.currentTarget as HTMLButtonElement
  $inputField.type = $inputField.type === 'password' ? 'text' : 'password'
  $button.innerHTML =
    $button.innerHTML === i18n('landingForm.show') ? i18n('landingForm.hide') : i18n('landingForm.show')
}

export function showPasswordToggler(): void {
  const $toggleButton = document.querySelector('[data-show-password-button]') as HTMLButtonElement
  if ($toggleButton) {
    initI18n().then(() => {
      $toggleButton.addEventListener('click', toggleInputType)
    })
  }
}
